// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aritce_details[data-v-5aca455c]{margin:4vw}.aritce_details h1[data-v-5aca455c]{color:#1a1a1a;font-size:4.8vw;text-align:center}.aritce_details .time[data-v-5aca455c]{color:#b3b3b3;font-size:3.2vw;margin:4vw 0}.aritce_details .centerbox[data-v-5aca455c]{color:#333;font-size:3.733vw}", ""]);
// Exports
module.exports = exports;
